export const chapter4 = [

    //page 34
    'A lone guard atop the wall called back for others to support,',
    'Soon the gates opened up after hearing his report,',
    'A mob of torches and people came out to meet,',
    'The town healer hurried over ready to treat,',
    '“She just collapsed, we fear it could be poison?”,',
    '“I‘ll see to her and help whatever the reason”,',
    '“Come all of you“ she directed them into her abode,',
    'It was filled with herbs of every sort and even a pet toad,',
    'They lay Andell on the floor and the old woman began to assess,',
    'She checked her wounds and used a crystal to gently press,',
    '“These injuries are not the root cause is my prediction”,',
    'She gathered some oils “I fear she suffers some malediction”,',

    //page 35
    '“It‘s serious, but I think you made it not a minute too late”,',
    '“She‘s in good hands now, go clean up, rest, time you ate”,',
    'The men traipsed to the tavern and collapsed each in a heap,',
    'They tidied wounds, inhaled some food then fell asleep,',
    'The dull moon drifted by behind the cloudy sky overhead,',
    'The healer worked on while everyone else was in bed,',
    '“Lazing about are you?” A curt voice awoke them from rest,',
    'They opened their eyes, Andell stood smiling again at her best,',
    '“Truly, from my heart I owe you all my deepest thanks”,',
    '“We put an end to the she-beast and cut down their ranks”,',
    '“We were worried, we had thought we lost you there for a bit”,',
    'Garson gestured, “But it seems you just don‘t quit!”,',
    '“Sorry, when you found me I had been awake for days, not a few”,',
    '“My sleep-block recipe was too strong from what I‘m use to”,',
    'Sigg took a note, “You are most skilled Andell, I‘m glad you are well”,',
    '“Have you seen the Governess? I have many things I‘d like to tell”,',
    'Andell‘s face dropped, “So they hadn‘t yet told you the bad news?”,',
    '“She was murdered while we were away, they are looking for clues”,',
    '“What!? how could this have happened? I did not see a breach”,',
    '“The walls remain up, someone inside had her within their reach”,',
    '“A few guards at the north gate were burned beyond recognition”,',
    '“I fear this assassination was work of a deranged magician”,',

    //page 36
    'With those word hanging in the air the captain of the guard walked in,',
    'He looked exhausted, “Ah there you are, I was delighted to hear of your win”,',
    '“As I hear you‘ve just heard, all has not been well here I‘m afraid”,',
    '“Our loved leader, has become victim to a plot with plans well made”,',
    '“We must move quickly to elect another and retain some stability”,',
    '“Just a few people have the skills and enough respectability”,',
    '“Andell, I suggest you throw your hat into the ring”,',
    '“With your recent victory it could be a sure thing”,',
    'Andell was genuinely shocked “Let me think on that suggestion”,',
    '“But I don‘t live in these walls, isn‘t there some next in succession?”,',
    'He chuckled, “This is no monarchy, there is little glory or fame”,',
    '“But from what I know yours is a well-respected name”,',
    'The captain bowed his head slightly as a respectful sign,',
    '“I‘ll be back later this afternoon with the town elders, nine”,',
    'Sigg piped up “With your vengeance on that beast now done”,',
    '“This could keep you busy and you might even find it fun!”,',
    'After some discussion over lunch Andell finally agreed,',
    '“You‘re right, a change in pace could be just what I need”,',
    'It turned out only two others tried out for the top job,',
    'Neither impressed the town elders, one greedy, one slob,',
    'So, by dinner time Andell was now the new Governess elect,',
    'She swore in “I will always do my best to govern and protect!”,',

    //page 37
    'And with a cheer from the elders it became a done deal,',
    'She was given the town robe, keys and the wax seal,',
    'Over the next few days the town returned to average,',
    'Time for wounds to mend, and enjoyed local beverage,',
    'At sunrise Sigg announced his departure, “I am heading north”,',
    'Garson said he‘d go too, “Let me pack then we can set forth”,',
    '“I‘d welcome the company, but can I ask where are you heading to?”',
    '“Breglon, small village much like this, I hear they make a fine stew”,',
    '“Perfect, that‘s on my way to Cragknoll. Anyone else want to join?”,',
    'Torgen remained silent, Corl offered, “Depends, you have more coin?”,',
    '“Thank you Corl, but I remember the north road being safe enough”,',
    '“Yes, if some beasts try to take on us both they will find it tough,”',
    'Garson said with a smile and packed up his travel bags full to the top,',
    '“Ok, let’s go“ Sig nodded, “Let’s try to pass the meadows before we stop”,',
    'Torgen, Corl and all the villagers waved, Andell walked the pair to the gate,',
    'She passed Garson a small stone, “If you get stuck, use this to communicate”,',
    'They were given traveller‘s cloaks as a parting gift and reward,',
    'Both men knew that their gratefulness exceeded what they could afford,',
    'They all shook hands and were wished well for their long trip,',
    '“Much thanks Andell, this place will thrive under your leadership”,',
    'The air felt fresh, Sigg felt a warmth in his soul,',
    'He was finally on his way back to Cragknoll,',

    //page 38
    '“We picked a good day to travel, the sky is looking clear”,',
    'Garson said, as he made sure remembered all his gear,',
    'Sigg clasped the heritage hammer tightly and vowed not to lose it again,',
    'He was thankfully losing it was not something he‘d now have to explain,',
    'They walked at a lively pace through the morning past crops and field,',
    'Now their gear was starting to get heavier, weapons, armour and shield,',
    'They shared a knowing look, neither one of them wanting to be cause,',
    'Of slowing the others journey but each yearned now for a pause,',
    'Garson spoke first “I need a minute to check my gear has not come a-miss”',
    '“Good idea, I drank too much with breakfast and I really need to take a piss”,',
    'It was a remote dirt path north and not many they expected to meet,',
    'So they sat underneath a tall oak tree and unladen their tired feet,',
    'Garson unpacked a few vials from his pack and gave them each a shake,',
    'He thought for a moment, smiled then knew what he wanted to make,',
    'Next, he popped a few corks and tipped some powder on the ground, ',
    'Sigg looked on in wonder as they made a strange popping sound,',
    'In disbelief he saw from a tiny size grew large a pot, pan, spoon and fork,',
    'A moment ago a speck now normal size even with a piece of salted pork,',
    'Each item had been inscribed in some unknown language, symbols or glyph?,',
    'Sigg was puzzled, “Is this for real?” he held the spoon and gave the meat a sniff,',

    //page 39
    'Garson couldn‘t hide a knowing smile, “Just a sample of what this can be used for ”,',
    '“I‘ve discovered how to condense many items down to their utmost core”,',
    '“My aim is unravel what binds together the physical, something to be sought”,',
    '“I‘ve dedicated my life to understanding, some call me a Welder of Thought”,',
    '“Astounding Garson!” Sigg added some notes to his book, and listened closely,',
    '“It takes me a few hours to bind something...“ Sigg understood mostly,',
    '“Everything we know is part of ‚The Ten Fabrics‘: Life, Fire, Time, Rocks”,',
    '“Thought, Enigma, Juice, Plant, Breath, Meat - like that of an Ox”,',
    '“You can shape anything with a combination of these - in the right way”,',
    '“Each has quality, soft, medium, hard, pure, sullied or corrupt as I say”,',
    'They began to cook up the meat and soon had a tasty meal to munch,',
    'The two of them talked more, soon the road called, they tidied up lunch,',
    '“Let’s see if we can make it to the bridge before the sun goes down”,',
    '“Yes, let’s keep a good pace, I would prefer to rest in the safely of town”,',
    'So, they continued to march north, each step taking them closer a bit,',
    'Some white fluffy clouds filled the sky, but they were still warm and sunlit,',
    'The faint call of home was nearly audible in Sigg‘s mind,',
    'He was closing in now, less ahead, much more was behind,',




];